
import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';

import configurationService from '../../../services/configuration-service.js';
const ViewCommsionGroup = () => { 
    const [commsion, setCommsion] = useState({});
    const [loading, setLoading] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate()

        const getCommsions = () => {
            setLoading(true);
            configurationService.getCommsionDetails(id)
                  .then(response => {
                    const data =response.data.data
                    setCommsion(data)
                    setLoading(false);
                  })
                  .catch(error => {
                    setLoading(false);
                    try {
                      const errorMessage = error.response.data
                      toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
                    } catch (e){
                      toast.error( MESSAGES.SERVER_ERROR)
                    }
                  });
          }
        useEffect(() => {
            getCommsions();
            document.body.style.backgroundImage = '';

            document.body.style.backgroundColor = '#f0f6fa';
            return () => {
              document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
            };
    }, []);
    const back = () => {
      navigate(-1); 
    }
    return(
      <div>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
      <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Commsion Details</h4>
      <div className="row ghty" style={{backgroundColor: 'white', height: 'auto', paddingBottom: '20px'}}>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Information</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
          <div className="tab-pane active" id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Group ID</label>
                      <p>{commsion.group_id || '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Group NAME</label>
                      <p>{commsion.group_name || '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Status</label>
                      <p>{commsion.status || '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">Registered On</label>
                      <p>{commsion.created_on || '-'}</p>
                    </div>
                  </div>
                  {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">BUSSINESS TYPE ID</label>
                      <p>{commsion.commsion_detail && commsion.commsion_detail.business_type_id ? commsion.commsion_detail.business_type_id : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">STATUS</label>
                      <p>{commsion.commsion_detail && commsion.commsion_detail.status ? commsion.commsion_detail.status : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">STATUS ID</label>
                      <p>{commsion.commsion_detail && commsion.commsion_detail.status_id ? commsion.commsion_detail.status_id : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">COMMISSION GROUP</label>
                      <p>{commsion.commsion_detail && commsion.commsion_detail.commision_group ? commsion.commsion_detail.commision_group : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">COMMISSION GROUP NAME</label>
                      <p>{commsion.commsion_detail && commsion.commsion_detail.comm_grp_name ? commsion.commsion_detail.comm_grp_name : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">CREATED ON</label>
                      <p>{commsion.commsion_detail && commsion.commsion_detail.created_on ? commsion.commsion_detail.created_on : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">CREATED BY</label>
                      <p>{commsion.commsion_detail && commsion.commsion_detail.created_by ? commsion.commsion_detail.created_by : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">UPDATED BY</label>
                      <p>{commsion.commsion_detail && commsion.commsion_detail.updated_by ? commsion.commsion_detail.updated_by : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">APPROVED BY</label>
                      <p>{commsion.commsion_detail && commsion.commsion_detail.approved_by ? commsion.commsion_detail.created_by : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">PROFILE PHOTO</label><br />
                      <img style={{margin: 0}} src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG.png" className="image-preview vjk" />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Pay In Information</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
          <div className="tab-pane active" id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>

                {commsion.payin && commsion.payin.slabs.map((comm, index) => ( 
                  <>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {index==0 && <label htmlFor="f_name">Commission Type</label>}
                      {index==0 && <p>{commsion.payin && commsion.payin.commission_type ?  commsion.payin.commission_type : '-'}</p>}
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    {index==0 && <label htmlFor="f_name">From Amount</label>}
                      <p>{comm.from_amount }</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    {index==0 && <label htmlFor="f_name">To Amount</label>}
                      <p>{comm.to_amount}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    {index==0 &&  <label htmlFor="f_name">Commission</label>}
                      <p>{comm.commission }</p>
                    </div>
                  </div>
                  </>
                ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Pay out Information</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
          <div className="tab-pane active" id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                {commsion.payout && commsion.payout.slabs.map((comm, index) => ( 
                    <>
                <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    {index==0 &&<label htmlFor="f_name">Commission Type</label>}
                    {index==0 &&  <p>{commsion.payout && commsion.payout.commission_type ?  commsion.payout.commission_type : '-'}</p>}
                    </div>
                  </div>

                
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    {index==0 && <label htmlFor="f_name">From Amount</label> }
                      <p>{comm.from_amount }</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    {index==0 &&<label htmlFor="f_name">To Amount</label>}
                      <p>{comm.to_amount}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    {index==0 &&<label htmlFor="f_name">Commission</label>}
                      <p>{comm.commission}</p>
                    </div>
                  </div>
                  </>
                  ))}
                  {/* <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">STATE ID</label>
                      <p>{commsion.address_detail && commsion.address_detail.state_id ? commsion.address_detail.state_id : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">STATE</label>
                      <p>{commsion.address_detail && commsion.address_detail.state ? commsion.address_detail.state : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">ZIP</label>
                      <p>{commsion.address_detail && commsion.address_detail.zip ? commsion.address_detail.zip : '-'}</p>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Bussiness Information</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
          <div className="tab-pane active" id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">BUSSINESS REGISTRATION NUMBER</label>
                      <p>{commsion.business_detail && commsion.business_detail.business_registration_number ? commsion.business_detail.business_registration_number : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">INDUSTRY TYPE ID</label>
                      <p>{commsion.business_detail && commsion.business_detail.industry_type_id ? commsion.business_detail.industry_type_id : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">INDUSTRY TYPE</label>
                      <p>{commsion.business_detail && commsion.business_detail.industry_type ? commsion.business_detail.industry_type : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">DESCRIPTION</label>
                      <p>{commsion.business_detail && commsion.business_detail.description ? commsion.business_detail.description : '-'}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Admin Information</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
          <div className="tab-pane active" id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">USER ID</label>
                      <p>{commsion.business_detail && commsion.business_detail.description ? commsion.business_detail.description : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">FULL NAME</label>
                      <p>{commsion.admin_detail && commsion.admin_detail.full_name ? commsion.admin_detail.full_name : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">EMAIL ADDRESS</label>
                      <p>{commsion.admin_detail && commsion.admin_detail.email_address ? commsion.admin_detail.email_address : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">MOBILE NUMBER</label>
                      <p>{commsion.admin_detail && commsion.admin_detail.mobile_number ? commsion.admin_detail.mobile_number : '-'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">IS VERIFICATION PENDING</label>
                      <p>{commsion.admin_detail && commsion.admin_detail.is_verification_pending ? 'true' : 'false'}</p>
                    </div>
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">AUTO GENERATE PASSWORD</label>
                      <p>{commsion.admin_detail && commsion.admin_detail.auto_generate_password ? 'true' : 'false'}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
         <a style={{width: 'auto', padding: '0px'}} onClick={back}><button className="btn btn-bg-theme-Color backbt">Back</button></a>
      </div>
    </div>
    </div>
    
    )
    
    } 
    function mapStateToProps(state) {
        const userData = state.authReducer.user;
        return { userData };
      }
  export default withAuth(connect(mapStateToProps)(ViewCommsionGroup));